var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMovieFilter = function SvgMovieFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "movie-filter_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#movie-filter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.817 12.217a6.735 6.735 0 0 1-1.092-1.942A6.593 6.593 0 0 1 1.333 8c0-1.744.576-3.244 1.726-4.5 1.15-1.256 2.574-1.967 4.274-2.133V2.7C6 2.856 4.89 3.433 4 4.433c-.889 1-1.333 2.19-1.333 3.567 0 .622.094 1.208.283 1.758.189.55.461 1.053.817 1.509l-.95.95ZM8 14.667a6.586 6.586 0 0 1-2.3-.4 6.649 6.649 0 0 1-1.95-1.117l.934-.95c.455.356.963.633 1.524.833.562.2 1.159.3 1.792.3s1.23-.1 1.792-.3c.56-.2 1.07-.477 1.525-.833l.933.95a6.65 6.65 0 0 1-1.95 1.117c-.722.266-1.489.4-2.3.4Zm5.184-2.45-.95-.95c.355-.456.627-.959.816-1.509.19-.55.284-1.136.284-1.758 0-1.378-.445-2.567-1.334-3.567S10 2.856 8.667 2.7V1.367c1.7.166 3.125.877 4.275 2.133 1.15 1.256 1.725 2.756 1.725 4.5 0 .8-.13 1.558-.392 2.275a6.735 6.735 0 0 1-1.091 1.942ZM6.334 11V5L11 8l-4.667 3Z"
  }))));
};
export default SvgMovieFilter;